import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-pink-100 bg-white/95 shadow-sm backdrop-blur" data-id="element-227" data-mp="232nfsn0fptzi">
      <div className="bg-primary px-3 py-1.5 text-center text-[10px] font-extrabold uppercase tracking-wide text-white sm:text-xs md:text-sm" data-id="element-228" data-mp="1y4ve519zmti4">
        🇦🇷 EL SISTEMA COMPLETO PARA INSTRUCTORES DE JUMPING EN ARGENTINA
      </div>
      <div className="mx-auto hidden max-w-5xl items-center justify-center gap-7 py-2 text-xs font-semibold text-slate-500 md:flex" data-id="element-229" data-mp="2qrohzsioc8wc">
        <span className="flex items-center gap-1.5" data-id="element-230" data-mp="2h2oh23km33fi">
          <ZapIcon className="h-3.5 w-3.5 text-primary" data-id="element-231" data-mp="2h13midyarkhn" /> Acceso en 5 minutos
        </span>
        <span className="text-pink-300" data-id="element-232" data-mp="2c2sem8rkbk22">·</span>
        <span className="flex items-center gap-1.5" data-id="element-233" data-mp="39iz8i8khmjnp">
          <LockIcon className="h-3.5 w-3.5 text-primary" data-id="element-234" data-mp="39jr0zaisg19r" /> Pago seguro
        </span>
        <span className="text-pink-300" data-id="element-235" data-mp="34r7pcj3nvg7l">·</span>
        <span className="flex items-center gap-1.5" data-id="element-236" data-mp="34qfs73uf1af7">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-primary" data-id="element-237" data-mp="26an0g6ypdxd" /> Garantía de 7 días
        </span>
      </div>
    </header>;
}